export default function IconNumberOfEmployees() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-b3f2a576-a789-4e8c-b3e0-dfe5fe19343a"
      data-name="Layer 2"
      viewBox="0 0 63.485 63.734"
    >
      <defs>
        <style>
          {
            ".uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207{fill:#392f2d;stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-512ae203-ad01-47f9-8fce-c02f604cf4dc" data-name="Layer 1">
        <g id="uuid-054f48d2-437c-42ec-9a1d-2218c7cb632a" data-name="g1014">
          <g id="uuid-7a29558f-33f8-43e5-8a1a-17bc8adda0ec" data-name="g1016">
            <g id="uuid-11e9e39e-9200-426c-a69e-cdbb08f26d7f" data-name="g1018">
              <path
                id="uuid-3c114302-9665-420b-a72a-e0d6d794ad45"
                d="M31.743 16.183c-4.462 0-8.092-3.63-8.092-8.092S27.281 0 31.743 0c1.766 0 3.446.56 4.856 1.619l-2.243 2.986a4.314 4.314 0 0 0-2.613-.87c-2.403 0-4.357 1.954-4.357 4.356s1.954 4.357 4.357 4.357c.95 0 1.855-.3 2.613-.87l2.243 2.986a8.025 8.025 0 0 1-4.856 1.619Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1024"
              />
              <path
                id="uuid-2b2f4bc0-5e8a-4273-b6f6-b93161f7d634"
                d="M39.211 16.183c-4.461 0-8.09-3.63-8.09-8.092S34.75 0 39.21 0c1.767 0 3.446.56 4.856 1.619l-2.243 2.986a4.314 4.314 0 0 0-2.613-.87c-2.402 0-4.357 1.954-4.357 4.356s1.955 4.357 4.357 4.357c.952 0 1.855-.3 2.613-.87l2.243 2.986a8.025 8.025 0 0 1-4.856 1.619Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1028"
              />
              <path
                id="uuid-a2fb4cc1-5d0e-4ca2-97b5-022c205d462f"
                d="M16.805 16.183c-4.461 0-8.091-3.63-8.091-8.092S12.344 0 16.805 0c1.766 0 3.445.56 4.856 1.619l-2.243 2.986a4.321 4.321 0 0 0-2.613-.87c-2.402 0-4.357 1.954-4.357 4.356s1.955 4.357 4.357 4.357c.951 0 1.855-.301 2.613-.87l2.243 2.986a8.025 8.025 0 0 1-4.856 1.619Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1032"
              />
              <path
                id="uuid-858ab603-511f-44fc-8947-33871abcf84e"
                d="M24.274 16.183c-4.462 0-8.091-3.63-8.091-8.092S19.813 0 24.273 0c1.767 0 3.446.56 4.856 1.619l-2.242 2.986a4.321 4.321 0 0 0-2.613-.87c-2.402 0-4.357 1.954-4.357 4.356s1.955 4.357 4.357 4.357c.951 0 1.854-.301 2.613-.87l2.242 2.986a8.025 8.025 0 0 1-4.855 1.619Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1036"
              />
              <path
                id="uuid-fdcfff76-dc6b-4780-acf1-73ef12f1246a"
                d="M22.407 29.253h3.734v32.614h-3.734z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1040"
              />
              <path
                id="uuid-1dffcf69-6495-4f6d-9c01-bd1ed2d10cd6"
                d="M18.672 61.867h-3.734V29.253c0-5.148 4.188-9.336 9.336-9.336v3.734a5.608 5.608 0 0 0-5.602 5.602v32.614Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1044"
              />
              <path
                id="uuid-8ab63abf-8aaa-40cf-b6b4-6da5e6a40dc7"
                d="M26.141 29.253h-3.734c0-5.148 4.188-9.336 9.336-9.336v3.734a5.608 5.608 0 0 0-5.602 5.602Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1048"
              />
              <path
                id="uuid-d4e32fd3-c026-4863-afc7-0d8e67d0d954"
                d="M46.68 16.183c-4.46 0-8.09-3.63-8.09-8.092S42.22 0 46.68 0s8.092 3.63 8.092 8.091-3.63 8.092-8.091 8.092Zm0-12.449c-2.402 0-4.356 1.955-4.356 4.357s1.954 4.357 4.357 4.357 4.356-1.954 4.356-4.357-1.954-4.357-4.356-4.357Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1052"
              />
              <path
                id="uuid-1b4f770a-32a0-45a5-8233-017fb9aa1765"
                d="M44.813 40.456h3.734v21.411h-3.734z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1056"
              />
              <path
                id="uuid-16f3bc0e-bf3d-4329-861a-b5014e2685bd"
                d="M37.344 27.386h3.734v34.481h-3.734z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1060"
              />
              <path
                id="uuid-64a43b05-a5e0-481d-b8c4-8e0a729b1381"
                d="M56.017 63.734H7.469V29.253c0-5.148 4.188-9.336 9.336-9.336v3.734a5.608 5.608 0 0 0-5.602 5.602V60h41.08V27.386h3.734v36.348Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1064"
              />
              <path
                id="uuid-148a9f00-966f-42ce-9db2-f9c2d481cfe3"
                d="M33.61 61.867h-3.734V29.253c0-5.148 4.188-9.336 9.335-9.336v3.734a5.608 5.608 0 0 0-5.601 5.602v32.614Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1068"
              />
              <path
                id="uuid-2295ab01-92b5-448e-bb80-4955158b9980"
                d="M39.211 56.266H0V29.253c0-5.148 4.188-9.336 9.336-9.336h44.813c5.148 0 9.336 4.188 9.336 9.336v11.204c0 3.088-2.512 5.601-5.601 5.601s-5.602-2.513-5.602-5.601h3.735c0 1.03.837 1.867 1.867 1.867s1.867-.838 1.867-1.867V29.253a5.608 5.608 0 0 0-5.602-5.602H9.336a5.608 5.608 0 0 0-5.602 5.602V52.53h35.477v3.735Z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1072"
              />
              <path
                id="uuid-59755b74-7f95-41f5-868b-9b6a8896e184"
                d="M44.813 21.784h3.734v13.07h-3.734z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1076"
              />
              <path
                id="uuid-1e43c581-9ee6-4f79-938c-c5eb05e72bcb"
                d="M1.867 38.589h37.344v3.734H1.867z"
                className="uuid-8989f626-b4d8-4d98-9da4-f23c6cb07207"
                data-name="g1080"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
